// extracted by mini-css-extract-plugin
export default {"navList":"nav_navList__mnk2M","isActive":"nav_isActive__Wt40E"};